export default __webpack_public_path__ + "static/media/LEGA9096.38b65415.jpg";